import { type FC } from 'react';
import {
  Prohibit
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconProhibitProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconProhibit: FC<UiIconProhibitProps> = (props) => {
  return (
    <UiIcon
      IconComponent={Prohibit}
      {...props}
    />
  );
};
